import React, { useEffect, useState } from "react";
import { getAdminFin, getTopCus } from "http/UAM/userDashboardWidget.helper";
import ToastDialog from "components/Common/ToastDialog";
import { useNavigate } from 'react-router-dom';
import { decryptedValue } from "common/utility";

const DataTable = ({ type }) => {
  const [data, setData] = useState([]);
  const [showStatus, setShowStatus] = useState(true);
  const [toastInfo, setToastInfo] = useState({ showToast: false, message: "", role: "" });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response;
        if (type === "financiers") {
          response = await getAdminFin();
        } else if (type === "customers") {
          response = await getTopCus();
        }
        if (response && response.status) {
          setData(response.data);
          setShowStatus(true);
        } else {
          setShowStatus(false);
          setData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setShowStatus(false);
        setData([]);
      }
    };

    fetchData();
  }, [type]);

  const navigateToDealList = async (event) => {
    const user = decryptedValue(localStorage.getItem("user"));
    navigate(`/${user.roleName}/listDeal?name=${event}&company_type=customer`);
  };

  const handleMouseEnter = (event) => {
    event.target.style.color = "#34c38f";
    event.target.style.textDecoration = 'underline';
  };
  const handleMouseLeave = (event) => {
    event.target.style.color = "black";
    event.target.style.textDecoration = 'none';
  };

  const maxRows = 5; // Maximum number of rows to display before scrolling
  const rowHeight = 50; // Height of each row
  const tableHeight = `${maxRows * rowHeight}px`; // Fixed height for the table container

  const tableContainerStyle = {
    height: showStatus ? tableHeight : "18.8rem", // Use calculated height if data is present, else fixed height
    overflowY:  "scroll", // Enable scrolling if data length exceeds maxRows
    borderCollapse: "collapse",
    width: "100%",
    boxShadow: "0px 5px 10px 0px rgba(0,0,0,0.1)",
    marginBottom: "20px",
  };

  const tableStyle = {
    width: "100%",
  };

  const thStyle = {
    background: "#21aa47eb",
    color: '#ffff',
    padding: "15px",
    textAlign: "left",
    borderBottom: "1px solid #ddd",
    borderRight: "1px solid #ddd",
  };

  const tdStyle = {
    padding: "15px",
    borderBottom: "1px solid #ddd",
    borderRight: "1px solid #ddd",
  };

  const tdFirstStyle = {
    ...tdStyle,
    cursor: 'pointer',
    borderLeft: "1px solid #ddd",
  };

  const trStyle = {
    height: `${rowHeight}px`, // Ensure each row has a consistent height
  };

  return (
    <>
      <div style={tableContainerStyle}>
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>{type === "financiers" ? "Top 5 Financiers" : "Top 5 Customers"}</th>
              <th style={thStyle}>{type === "financiers" ? "Interested on Deals" : "Number of Deals"}</th>
            </tr>
          </thead>
          {showStatus ? (
            <tbody>
              {data.map((item) => (
                <tr key={type === "financiers" ? item.financier.id : item.entity.id} style={trStyle}>
                  {type === "customers" &&
                    <td onClick={() => navigateToDealList(item.entity.id)}
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                      style={tdFirstStyle}
                      value={item.entity.entity_name}
                    >{item.entity.entity_name}
                    </td>}
                    {type === "financiers" &&
                    <td
                      style={tdFirstStyle}
                      value={item.financier.entityName}
                    >{item.financier.entityName}
                    </td>}
                  {/* {type === "financiers" && <td style={tdFirstStyle}>{item.financier.entityName}</td>} */}
                  <td style={tdFirstStyle}>{type === "financiers" ? item.dealCount : parseInt(item.dealCount)}</td>
                </tr>
              ))}
              {/* Add empty rows if necessary to maintain the minimum number of rows */}
              {data.length < maxRows &&
                Array.from({ length: maxRows - data.length }).map((_, index) => (
                  <tr key={`empty-${index}`} style={trStyle}>
                    <td style={tdFirstStyle}></td>
                    <td style={tdFirstStyle}></td>
                  </tr>
                ))}
            </tbody>
          ) : (
            <tbody style={{ height: "15.8rem" }}>
              <tr>
                <td colSpan="2" style={{ textAlign: 'center' }}>
                  <p className="pt-4 pb-4 fs-4 fw-normal">No Data Found</p>
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </>
  );
};

export default DataTable;

